// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MHAStatus_mhaPage__\\+rz2T {
  height: 100%;
  width: 100%;
  position: relative;
}

.MHAStatus_mhaContent__qHYpH {
  padding: 20px;
}
.MHAStatus_mhaContent__qHYpH h2 {
  margin-bottom: 24px;
  color: #1D283C;
}
.MHAStatus_mhaContent__qHYpH p {
  margin-bottom: 32px;
  color: #666;
  line-height: 1.6;
}

.MHAStatus_statsContainer__q\\+qEg {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.MHAStatus_statCard__6fwxX {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1;
}
.MHAStatus_statCard__6fwxX h3 {
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
}
.MHAStatus_statCard__6fwxX .MHAStatus_statValue__u6qYV {
  font-size: 24px;
  font-weight: 600;
  color: #1D283C;
}`, "",{"version":3,"sources":["webpack://./src/pages/MHAStatus/MHAStatus.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;AACF;AACE;EACE,mBAAA;EACA,cAAA;AACJ;AAEE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,SAAA;AADF;AAGE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFJ","sourcesContent":[".mhaPage {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n\n.mhaContent {\n  padding: 20px;\n  \n  h2 {\n    margin-bottom: 24px;\n    color: #1D283C;\n  }\n  \n  p {\n    margin-bottom: 32px;\n    color: #666;\n    line-height: 1.6;\n  }\n}\n\n.statsContainer {\n  display: flex;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.statCard {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  flex: 1;\n  \n  h3 {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 12px;\n  }\n  \n  .statValue {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1D283C;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mhaPage": `MHAStatus_mhaPage__+rz2T`,
	"mhaContent": `MHAStatus_mhaContent__qHYpH`,
	"statsContainer": `MHAStatus_statsContainer__q+qEg`,
	"statCard": `MHAStatus_statCard__6fwxX`,
	"statValue": `MHAStatus_statValue__u6qYV`
};
export default ___CSS_LOADER_EXPORT___;
